import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'ordenarFecha'})
export class OrdenarFechaPipe implements PipeTransform {
  transform(array: any[], nodo: string, ascendente?: boolean): any {
    
    if (array ? !array.length : true) return array || [];
    if (!nodo) return array || [];
    return array.sort((b: any, a: any) => {
      const uno = ascendente ? (a[nodo] || "") : (b[nodo] || "");
      const dos = ascendente ? (b[nodo] || "") : (a[nodo] || "");
      if (uno < dos) return -1;
      else if (uno > dos) return 1;
      else return 0;
    });
  }
}